module.exports = __webpack_public_path__ + "media/negative.c071d41c.wav";